<div class="container shared-container container-design">
    <div class="row justify-content-center">
        <div class="col-12 col-md-7 col-lg-5 col-xl-4 card-size">
            <h1 class="purchase-design-title text-center text-sm-start">
                {{ 'vg_landing_purchase_design_h1_title' | translate }}
            </h1>
            <vg-card-giftcard-design
                [title]="selectedCard?.alternateText! | singleTranslation"
                [img]="currentImage"
            >
            </vg-card-giftcard-design>
            <vg-swiper-giftcard-design
                (selectedCard)="onSelectedCard($event)"
                (imgChange)="onImgChange($event)"
            ></vg-swiper-giftcard-design>
            <ng-container
                *ngIf="'/purchase/amount' | formatUrl | async as formattedUrl"
            >
                <vg-button
                    (click)="onClickNextAndNextStep(formattedUrl)"
                    class="d-grid w-100"
                    [style]="'success-outline'"
                >
                    {{ 'vg_landing_purchase_design_btn_next' | translate }}
                </vg-button>
            </ng-container>
        </div>
    </div>
</div>
